<template>
  <String class="string--red-green" :strLength="this.strLength">
    <Red :brightness="channelOneBrightness"/>
    <Green :brightness="channelTwoBrightness"/>
  </String>
</template>

<script>
  import String from './String';
  import Red from '../Lights/Red';
  import Green from '../Lights/Green';

  export default {
    name: 'RedGreenString',
    components: {
      String,
      Red,
      Green
    },
    props: {
      channelOneBrightness: Number,
      channelTwoBrightness: Number,
      strLength: {
        type: Number,
        default: 20
      }
    }
  };
</script>

<style>

</style>
